import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import MainContentContainer from "./MainContentContainer";
import { Box, createTheme, Stack, ThemeProvider, Avatar } from "@mui/material";
import "./DashboardContainer.css";
import RightStatBar from "./RightStatBar";
import InterestGrids from "../auth/InterestGrids";
import { useDispatch, useSelector } from "react-redux";
import Modal from "@mui/material/Modal";

const OurDashboard = ({
  isMain,
  type,
  searchedText,
  showSidebar,
  setShowSidebar,
  themeMode,
  setThemeMode,
}) => {
  const [showInterestCollectionGrid, setShowInterestCollectionGrid] =
    useState(false);
  const handleOpen = () => setShowInterestCollectionGrid(true);
  const handleClose = () => setShowInterestCollectionGrid(false);
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  useEffect(() => {
    if (
      currentUser?.userRole == "student" ||
      currentUser?.userRole == "alumni"
    ) {
      if (currentUser?.categoriesInterested?.length > 0) {
        setShowInterestCollectionGrid(false);
      } else {
        setShowInterestCollectionGrid(true);
      }
    }
  }, [currentUser]);
  return (
    <>
      <Modal
        open={showInterestCollectionGrid}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <InterestGrids
          currentUser={currentUser}
          setShowInterestCollectionGrid={setShowInterestCollectionGrid}
        />
      </Modal>

      <Box
        className="our__dasboard__page"
        sx={{
          display: "flex",
          overflow: "hidden",
          backgroundColor: "colorWhite.main",
        }}
      >
        <Sidebar
          themeMode={themeMode}
          setThemeMode={setThemeMode}
          showSidebar={showSidebar}
          setShowSidebar={setShowSidebar}
        />
        <MainContentContainer
          mode={themeMode}
          setMode={setThemeMode}
          showSidebar={showSidebar}
          setShowSidebar={setShowSidebar}
          type={type}
          searchedText={searchedText}
          setShowInterestCollectionGrid={setShowInterestCollectionGrid}
        />
        {type !== "settings" && type !== "profile" && (
          <RightStatBar type={type} />
        )}

        <Box
          className="sidebar__cover"
          sx={{ left: !showSidebar ? "-120%" : "0" }}
        ></Box>
      </Box>
    </>
  );
};

export default OurDashboard;
